import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import propTypes from "prop-types";
import ObjectHelper from "../../helpers/ObjectHelper";

import Loading from "../../Components/Loading";

const mapDispatchToProps = dispatch => ({});

class SummaryList extends Component {
  static propTypes = {
    reportGroup: propTypes.array,
    dateRange: propTypes.array,
  };

  state = {
    isFetched: false,
    isFetching: false,
    sort: ["cityName", true]
  };

  renderReportCell = ({ reports, theatreId, cityId }, date) => {
    for (let idx = 0; idx < reports.length; idx++) {
      const { key, money } = reports[idx];
      if (key === date) {
        return (
          <td
            key={"moneyKey-" + theatreId + "-" + date}
            id={key}
            className="small-column linkTd"
            onClick={() => this.createReportLink(key, cityId, theatreId)}
          >
            {money || ""}
          </td>
        );
      }
    }
    return (
      <td
        key={"moneyKey-" + theatreId + "-" + date}
        className="small-column linkTd"
      >
        0
      </td>
    );
  };

  createReportLink = (date, cityId, cinemaId) => {
    let link = ["city=" + cityId, "theatre=" + cinemaId, "date=" + date];
    this.props.history.push("reports-download?" + link.join("&"));
  };

  setSort = name => {
    const sort = this.state.sort || [];
    if (sort[0] === name) {
      sort[1] = !sort[1];
    } else {
      sort[0] = name;
      sort[1] = true;
    }
    this.setState({ sort });
  };

  getSortTitle(sortName, sortLabel) {
    const sort = this.state.sort || [];
    if (sort[0] !== sortName) {
      return <span>{sortLabel}</span>;
    }

    return (
      <Fragment>
        <span className="active">
          {sortLabel}
          &nbsp;
        </span>
        <img
          src={
            sort[1]
              ? "/images/icon-arrow-down-blue.png"
              : "/images/icon-arrow-up.png"
          }
          alt=""
        />
      </Fragment>
    );
  }

  getReportGroup() {
    const { sort: [sortAttr, sortAsc] } = this.state;
    const { reportGroup } = this.props;
    const sort = sortAsc
      ? (a, b) => {
        if (ObjectHelper.get(a, sortAttr) > ObjectHelper.get(b, sortAttr)) {
          return 1;
        }
        if (ObjectHelper.get(a, sortAttr) < ObjectHelper.get(b, sortAttr)) {
          return -1;
        }
        return 0;
      }
      : (a, b) => {
        if (ObjectHelper.get(b, sortAttr) > ObjectHelper.get(a, sortAttr)) {
          return 1;
        }
        if (ObjectHelper.get(b, sortAttr) < ObjectHelper.get(a, sortAttr)) {
          return -1;
        }
        return 0;
      };
    return (reportGroup || []).sort(sort);
  }

  render() {
    const { isFetched, isFetching } = this.state;
    if (!isFetched && isFetching) {
      return <Loading loading />;
    }
    return (
      <div className="office-report office-report__summary">
        <div className="office-report__header">
          <button className="btn-gradient">Скачать отчет</button>
        </div>
        {(this.props.reportGroup.length && (
          <div className="office-report__body" style={{ overflow: "auto" }}>
            <table className="office__table">
              <thead>
                <tr>
                  <td
                    className="large-column filter-column"
                    onClick={() => this.setSort("theatreName")}
                  >
                    {this.getSortTitle("theatreName", "Кинотеатр")}
                  </td>
                  <td
                    className="large-column filter-column"
                    onClick={() => this.setSort("cityName")}
                  >
                    {this.getSortTitle("cityName", "Город")}
                  </td>
                  {this.props.dateRange.map((element, index) => (
                    <td
                      key={"dateKey-" + index}
                      className="small-column separator"
                    >
                      <span>{element.value}</span>
                    </td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {this.getReportGroup().map((element, index) => (
                  <tr key={"tr:" + index}>
                    <td className="large-column" colSpan="2">
                      <div className="name">{element.theatreName}</div>
                      <div className="city gray">{element.cityName}</div>
                    </td>
                    {this.props.dateRange.map((date, dateIndex) =>
                      this.renderReportCell(element, date.key)
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )) ||
          ""}
      </div>
    );
  }
}
export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SummaryList)
);



// WEBPACK FOOTER //
// ./src/containers/summary/_list.jsx